"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const chalk_1 = __importDefault(require("chalk"));
const util_1 = require("util");
const formatDate_1 = __importDefault(require("./formatDate"));
class Message {
    constructor() {
        this.stack = '';
    }
}
function formatError(error) {
    return `${error.name}: ${error.message}\n${error.stack}`;
}
class Logger {
    constructor() {
        this._transport = [];
        this._level = 0;
    }
    static get instance() {
        if (!this._instance)
            this._instance = new Logger();
        return Logger._instance;
    }
    static init(config) {
        if (!this._instance)
            this._instance = new Logger();
        Logger.instance.init(config);
        return Logger.instance;
    }
    init(config) {
        if (config === null || config === void 0 ? void 0 : config.transport)
            this._transport = config.transport;
    }
    get level() {
        return this._level;
    }
    set level(level) {
        this._level = level;
    }
    static get level() {
        return Logger._instance.level;
    }
    static set level(level) {
        Logger._instance.level = level;
    }
    static verbose(message, transport = true) {
        return Logger.instance.verbose(message, transport);
    }
    static debug(message, transport = true) {
        return Logger.instance.debug(message, transport);
    }
    static info(message, transport = true) {
        return Logger.instance.info(message, transport);
    }
    static success(message, transport = true) {
        return Logger.instance.success(message, transport);
    }
    static warn(message, transport = true) {
        return Logger.instance.warn(message, transport);
    }
    static error(message, transport = true) {
        return Logger.instance.error(message, transport);
    }
    static log(message, level = Logger.LEVELS.VERBOSE, color = 'white') {
        return Logger.instance.log(message, level, color);
    }
    verbose(message, transport = true) {
        return this.log(message, Logger.LEVELS.VERBOSE, 'white', transport);
    }
    debug(message, transport = true) {
        return this.log(message, Logger.LEVELS.DEBUG, 'white', transport);
    }
    info(message, transport = true) {
        return this.log(message, Logger.LEVELS.INFO, 'blue', transport);
    }
    success(message, transport = true) {
        return this.log(message, Logger.LEVELS.SUCCESS, 'green', transport);
    }
    warn(message, transport = true) {
        return this.log(message, Logger.LEVELS.WARNING, '#FFAA44', transport);
    }
    error(message, transport = true) {
        return this.log(message, Logger.LEVELS.ERROR, 'red', transport);
    }
    log(message, level = Logger.LEVELS.VERBOSE, color = 'white', transport = true) {
        if (!message)
            return;
        if (message instanceof Message)
            message = message.stack;
        if (message instanceof Error) {
            const err = message;
            if (err.isAxiosError) {
                message = formatError(err) + "\n" + util_1.inspect({
                    isAxiosError: err.isAxiosError,
                    config: err.config,
                    response: err.response
                        ? {
                            status: err.response.status,
                            headers: err.response.headers,
                            data: err.response.data,
                        }
                        : undefined,
                }, false, 10);
            }
            else {
                message = util_1.inspect(err, false, 10);
            }
        }
        else if (typeof message === 'object')
            message = util_1.inspect(message, false, 10);
        const now = formatDate_1.default(new Date());
        let datedMessage = '[' + now + '] ' + message;
        if (!chalk_1.default[color]) {
            datedMessage = chalk_1.default.hex(color)(datedMessage);
            color = 'white';
        }
        if (level >= this.level) {
            console.log(chalk_1.default[color](datedMessage));
            if (transport) {
                for (const method of this._transport) {
                    method(LEVEL_MAPS[level], message);
                }
            }
        }
    }
}
exports.Logger = Logger;
Logger._instance = new Logger();
const LEVEL_MAPS = ['log', 'debug', 'info', 'warn', 'error', 'success'];
(function (Logger) {
    let LEVELS;
    (function (LEVELS) {
        LEVELS[LEVELS["VERBOSE"] = 0] = "VERBOSE";
        LEVELS[LEVELS["DEBUG"] = 1] = "DEBUG";
        LEVELS[LEVELS["INFO"] = 2] = "INFO";
        LEVELS[LEVELS["SUCCESS"] = 3] = "SUCCESS";
        LEVELS[LEVELS["WARNING"] = 4] = "WARNING";
        LEVELS[LEVELS["ERROR"] = 5] = "ERROR";
    })(LEVELS = Logger.LEVELS || (Logger.LEVELS = {}));
})(Logger = exports.Logger || (exports.Logger = {}));
Logger.level = Logger.LEVELS.VERBOSE;
